import { PreCheckinFormCustomization } from '@precheckin/models/precheckin-form-customization/precheckin-form-customization.model';

export interface IPreCheckinFormCustomizationStateModel {
  isFormCustomizationReady: boolean;
  preCheckinFormCustomization: PreCheckinFormCustomization;
}

export const defaultPreCheckinFormState = {
  isFormCustomizationReady: false,
  preCheckinFormCustomization: new PreCheckinFormCustomization()
} as IPreCheckinFormCustomizationStateModel;
